<template>
  <div class="projectmanagedetail">
    <div class="page-title">
      <div class="page-nav-items">
        <span class="page-parentname" @click="Back">项目管理></span
        ><span>{{ showOperateName }}</span>
      </div>
    </div>
    <div :class="['appid-secret-box', operateName !== 'new' ? '' : '']">
      <div class="appid-secret-main">
        <div class="item-container">
          <div class="label">APP ID</div>
          <div class="dot">：</div>
          <div>
            {{
              projectForm && projectForm.mid_table_remark_002
                ? projectForm.mid_table_remark_002
                : "创建后展示"
            }}
          </div>
        </div>
        <div class="item-container">
          <div class="label">APP Secret</div>
          <div class="dot">：</div>
          <div>
            {{
              projectForm && projectForm.mid_table_remark_003
                ? projectForm.mid_table_remark_003
                : "创建后展示"
            }}
          </div>
        </div>
      </div>
      <div class="type-icon">
        <img v-if="projectTypeIcon" :src="projectTypeIcon" />
      </div>
    </div>
    <el-form
      ref="projectForm"
      :model="projectForm"
      class="form-box"
      label-width="100px"
      label-position="left"
    >
      <el-form-item
        prop="mid_table_remark_001"
        label="项目名称："
        :rules="rules.project_name"
        class="custom-el-form-item"
      >
        <el-input
          class="custom-input txt-normalstyle"
          placeholder="请填写"
          v-model="projectForm.mid_table_remark_001"
          :readonly="operateName == 'search'"
        >
        </el-input>
      </el-form-item>
      <div class="from_item_flex">
        <el-form-item
          prop="mid_table_remark_007"
          label="项目分类："
          class="custom-el-form-item"
          :rules="rules.project_type"
        >
          <!-- :multiple-limit="3"
            multiple -->
          <template v-if="operateName == 'search'">
            <el-input
              class="custom-input txt-normalstyle width492"
              :value="
                projectForm.mid_table_remark_007
                  | showProjectType(projectTypeList, 'value', 'text')
              "
              readonly
            >
            </el-input>
          </template>

          <template v-else>
            <CustomSelect
              class="width492"
              style="min-height: 46px"
              v-model="projectForm.mid_table_remark_007_Value"
              placeholder="请选择"
              popper-class="customselect-popper"
              value-key="value"
              otherValue="212"
              :disabled="operateName == 'search'"
              @change="projectTypeChange"
            >
              <el-option
                v-for="(item, idx) in projectTypeList"
                :key="idx"
                :label="item.text"
                :value="item"
                :remark="item.value"
              >
              </el-option>
            </CustomSelect>
          </template>
        </el-form-item>
        <el-form-item
          prop="mid_table_remark_012"
          label="ECS过期时间："
          class="custom-el-form-item"
        >
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="projectForm.mid_table_remark_012"
              :readonly="operateName == 'search'"
            ></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item
          prop="mid_table_remark_013"
          label="RDS过期时间："
          class="custom-el-form-item"
        >
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="projectForm.mid_table_remark_013"
              :readonly="operateName == 'search'"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </div>

      <el-form-item
        prop="mid_table_remark_006"
        label="项目描述："
        class="custom-el-form-item"
        :rules="rules.project_desc"
      >
        <el-input
          class="custom-input txt-normalstyle project-desc custom-txt"
          placeholder="请填写"
          v-model="projectForm.mid_table_remark_006"
          type="textarea"
          maxlength="200"
          show-word-limit
          :readonly="operateName == 'search'"
        ></el-input>
      </el-form-item>
        <el-form-item v-if="operateName == 'search'" label="项目协作者：">
            <template>
            <el-input
                class="custom-input txt-normalstyle width856"
                placeholder="请选择"
                v-model="userNameStr"
                :readonly="true"
            >
            </el-input>
            </template>
        </el-form-item>
        <el-form-item v-else label="项目协作者：">
            <el-row>
                <div class="goods-label">
                    <span class="label-title"></span>
                    <div v-if="projectForm.mid_table_remark_011_Value">
                        <el-tag style="margin:0 12px 12px 0;border:none;height:40px;font-size:15px;line-height:40px" type="success" v-for="(item, index) of projectForm.mid_table_remark_011_Value" :key="index" closable @close="closeTag(item, index)">
                            <span>{{ item.nick_name }}</span>(ID：<span>{{ item.id_public_user_info }}</span>)
                        </el-tag>
                    </div>
                </div>
            </el-row>
            <el-select
                class="custom-input"
                style="min-height: 50px;width:350px"
                filterable
                remote
                v-model="selectPartner"
                placeholder="请选择"
                popper-class="customselect-popper"
                :remote-method="remoteMethod"
                :loading="selectLoading"
                @change="demandTypeChange"
                clearable >
                <el-option
                    v-for="(item, idx) in demandTypeList"
                    :key="idx"
                    :label="item.text"
                    :value="item"
                    :remark="item.value"
                >
                </el-option>
            </el-select>
            <el-button style="margin-left: 12px;height:46px" type="primary" @click="addPartner" class="custom-button btn-ff3333 btn-publish">添加</el-button>
        </el-form-item>
      <el-form-item
        prop="mid_table_remark_014"
        label="蓝湖链接："
        class="custom-el-form-item"
      >
        <el-input
          class="custom-input txt-normalstyle"
          placeholder="请填写"
          v-model="projectForm.mid_table_remark_014"
          :readonly="operateName == 'search'"
        >
        </el-input>
      </el-form-item>
      <el-form-item
        prop="mid_table_remark_015"
        label="墨刀链接："
        class="custom-el-form-item"
      >
        <el-input
          class="custom-input txt-normalstyle"
          placeholder="请填写"
          v-model="projectForm.mid_table_remark_015"
          :readonly="operateName == 'search'"
        >
        </el-input>
      </el-form-item>

      <el-form-item prop="project_desc" label="白名单总数：">
        <div class="white-count-box">
          <div class="white-count">{{ projectForm.mid_table_remark_008 }}</div>
          个，
          <div>
            还可以添加<b style="color: red">{{
              projectForm.mid_table_remark_008 -
              testWhiteList.length -
              releaseWhiteList.length
            }}</b
            >个
          </div>
        </div>
      </el-form-item>
      <el-form-item prop="project_desc" label="测试白名单：">
        <div class="Whitelist" v-if="operateName !== 'search'">
          如果需要设置多个白名单，请用<b>英文状态下逗号</b>隔开，如：192.168.0.1
          , 192.168.0.2 删除白名单请将白名单前的逗号也删除
        </div>
        <el-input
          class="custom-input txt-normalstyle project-desc custom-txt"
          placeholder="请填写"
          v-model="projectForm.mid_table_remark_004"
          type="textarea"
          v-if="operateName !== 'search'"
          @blur="handleCheckCount"
        ></el-input>
        <div class="ip-box">
          <div class="read-iplist-box" v-if="operateName === 'search'">
            <div
              v-for="(item, idx) in testWhiteList"
              :key="idx"
              class="read-ip-item-box"
            >
              <el-input
                class="custom-input txt-normalstyle width492"
                :value="item"
                :readonly="operateName == 'search'"
              >
              </el-input>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item prop="project_desc" label="正式白名单：">
        <div class="Whitelist" v-if="operateName !== 'search'">
          如果需要设置多个白名单，请用<b>英文状态下逗号</b>隔开，如：192.168.0.1
          , 192.168.0.2 删除白名单请将白名单前的逗号也删除
        </div>
        <el-input
            class="custom-input txt-normalstyle project-desc custom-txt"
            placeholder="请填写"
            v-model="projectForm.mid_table_remark_005"
            type="textarea"
            v-if="operateName !== 'search'"
            @blur="handleReleaseCheckCount"
        ></el-input>
        <div class="ip-box">
          <div class="read-iplist-box" v-if="operateName === 'search'">
            <div
              v-for="(item, idx) in releaseWhiteList"
              :key="idx"
              class="read-ip-item-box"
            >
              <el-input
                class="custom-input txt-normalstyle width492"
                :value="item"
                :readonly="operateName == 'search'"
              >
              </el-input>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <template v-if="operateName === 'new' || operateName === 'edit'">
          <el-button
            v-if="operateName === 'new'"
            class="custom-button btn-ff3333 btn-publish"
            @click="handleSubmit"
            >创建项目</el-button
          >
          <el-button
            v-if="operateName === 'edit'"
            class="custom-button btn-ff3333 btn-publish"
            @click="handleSubmit"
            >编辑项目</el-button
          >
          <el-button
            class="custom-button btn-e0e0e0 btn-cancel"
            @click="goHistory"
            >取消</el-button
          >
        </template>
        <template v-if="operateName === 'search'">
          <el-button
            class="custom-button btn-border btn-back"
            @click="goHistory"
            >返回</el-button
          >
        </template>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import CustomSelect from "@/components/CustomSelect.vue";
import { projectTypeOptions } from "@/assets/js/dictionary";
import { checkDataFromDictionary } from "@/utils/tool";
import lodash from "lodash";
import pageCommon from "@/utils/pagecommon";
import projectApi from "@/api/project";
export default {
  name: "ProjectManageDetail",
  components: { CustomSelect },
  data() {
    return {
      demandTypeList: [],
      projectTypeList: [],
      projectList: [],
      operateName: "",
      projectId: "",
      projectForm: {
        //项目名称
        mid_table_remark_001: "",
        mid_table_remark_002: "",
        mid_table_remark_003: "",
        // 项目描述
        mid_table_remark_006: "",
        // 项目分类
        mid_table_remark_007_Value: null,
        mid_table_remark_007: null,
        // 测试IP白名单
        mid_table_remark_004: null,
        // 正式IP白名单
        mid_table_remark_005: null,
        // 白名单个数
        mid_table_remark_008: 0,
      },
      setWhiteCount: 0,
      setSeleaseCount: 0,
      newTestIpInput: [],
      newReleaseInput: [],
      rules: {
        project_name: [
          { required: true, message: "填写项目名称", trigger: "blur" },
        ],
        project_desc: [
          { required: true, message: "填写项目描述", trigger: "blur" },
        ],
        project_type: [
          { required: true, message: "选择项目分类", trigger: "change" },
        ],
      },
      isRequesting: false,
      projectTypeIcon: "",
      selectLoading: false,
      userNameStr:'',
      selectPartner:''
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
    disabledLoadMore: function () {
      let _this = this;
    },
    showOperateName: function () {
      let _this = this;
      if (_this.operateName === "new") {
        return "新建项目";
      }
      if (_this.operateName === "edit") {
        return "编辑项目";
      }
      if (_this.operateName === "search") {
        return "查看项目";
      }
    },
    newTestIpButtonStatus: function () {
      let _this = this;
      if (
        _this.newTestIpInput[0] &&
        _this.newTestIpInput[1] &&
        _this.newTestIpInput[2] &&
        _this.newTestIpInput[3]
      ) {
        return true;
      }
      return false;
    },
    newReleaseIpButtonStatus: function () {
      let _this = this;
      if (
        _this.newReleaseInput[0] &&
        _this.newReleaseInput[1] &&
        _this.newReleaseInput[2] &&
        _this.newReleaseInput[3]
      ) {
        return true;
      }
      return false;
    },
    testWhiteList: function () {
      let _this = this;
      if (_this.projectForm && _this.projectForm.mid_table_remark_004) {
        let ipArr = _this.projectForm.mid_table_remark_004.split(",");
        return ipArr;
      }
      return [];
    },
    releaseWhiteList: function () {
      let _this = this;
      if (_this.projectForm && _this.projectForm.mid_table_remark_005) {
        let ipArr = _this.projectForm.mid_table_remark_005.split(",");
        return ipArr;
      }
      return [];
    },
  },
  created() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 1);
  },
  mounted: function () {
    let _this = this;
    _this.getIndustryList();
    // _this.getUserList();

    let operate = _this.$route.query.o;
    if (!operate) {
      _this.$router.go(-1);
      return;
    }
    let id = _this.$route.query.id;
    if (operate !== "new" && !id && id !== 0) {
      _this.$router.go(-1);
      return;
    }
    _this.operateName = operate;
    _this.projectId = id;
    if (_this.projectId) {
      // 获取项目详情
      setTimeout(() => {
        _this.getProjectDetail();
      }, 1000);
    } else {
      let countNumber = 0;
      // if (_this.userInfo.user_remark_012 === "1202") {
        countNumber = 10;
      // } else {
      //   countNumber = 1;
      // }

      _this.projectForm = {
        //项目名称
        mid_table_remark_001: "",
        // 项目描述
        mid_table_remark_006: "",
        // 项目分类
        mid_table_remark_007_Value: null,
        mid_table_remark_007: null,
        // 测试IP白名单
        mid_table_remark_004: null,
        // 正式IP白名单
        mid_table_remark_005: null,
        // 白名单个数
        mid_table_remark_008: countNumber,
        mid_table_remark_009: 901,
        mid_table_remark_011_Value:[],
        mid_table_remark_002: "",
        mid_table_remark_003: "",
      };
    }
  },
  filters: {
    showProjectType: function (val, list, checkprop, resultprop) {
      return checkDataFromDictionary(`${val}`, list, checkprop, resultprop);
    },
  },
  methods: {
    showLocalDictionaryVal: function (val,type) {
      let _this=this;
      if(val){
        let requestData = {
          isloading: true,
          userId: val
        };
        pageCommon.apiRequestCommon(projectApi, "getUserList", requestData).then(
          (res) => {
            let userData = res.page_content;
            let userName = []
            let userNameStr = ''
            userData.forEach((item) => {
              userName.push(item.nick_name);
            });
            userNameStr = userName.join('，')
            if(type=='list'){
                return userName
            } else {
                _this.userNameStr=userNameStr;
            }
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );
      }
    },
    remoteMethod(query) {
      let _this = this;
      if (query !== '') {
            this.selectLoading = true;
            let requestData = {
                isloading: true,
                nick_name: query
            };
            _this.demandTypeList=[]
            pageCommon.apiRequestCommon(projectApi, "getUserList", requestData).then(
                (res) => {
                this.selectLoading = false;
                let userData = res.page_content;
                userData.forEach((item) => {
                    if (
                        item.nick_name !== "匿名" &&
                        item.nick_name !== "-1" &&
                        item.id_public_user_info !== _this.userInfo.id_public_user_info
                    ) {
                        _this.demandTypeList.push({
                            text: item.nick_name,
                            value: item.id_public_user_info,
                            remark: "",
                        });
                    }
                });
                },
                (err) => {
                if (err.sysUserLoginError) {
                    _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                    _this.$message.error(err.data.msg);
                }
                }
            );
      } else {
        this.demandTypeList = [];
      }
    },
    Back: function () {
      let _this = this;
      _this.$router.go(-1);
    },
    goHistory: function () {
      let _this = this;
      _this.$router.go(-1);
    },
    getProjectDetail: function () {
      let _this = this;
      let requestData = {
        begin_idx: 0,
        limit: 10,
        isloading: true,
        id_public_middle_table: _this.projectId,
        id_public_user_info: _this.$route.query.userId,
      };
      pageCommon.apiRequestCommon(projectApi, "getDetail", requestData).then(
        (res) => {
            let tmp =
            res && res.page_content && res.page_content.length
                ? res.page_content[0]
                : null;
            if (!tmp) {
                _this.goHistory();
                return;
            }

            if (tmp.mid_table_remark_004) {
                _this.setWhiteCount =
                Number(tmp.mid_table_remark_008) -
                tmp.mid_table_remark_004.split(",").length;
            }
            if (tmp.mid_table_remark_005) {
                _this.setSeleaseCount =
                Number(tmp.mid_table_remark_008) -
                tmp.mid_table_remark_005.split(",").length;
            }
            if (tmp.mid_table_remark_007) {
                for (let i = 0; i < _this.projectTypeList.length; i++) {
                    const tmpType = _this.projectTypeList[i];
                    if (tmpType.value == tmp.mid_table_remark_007) {
                        tmp.mid_table_remark_007_Value = lodash.cloneDeep(tmpType);
                        _this.projectTypeIcon = _this.projectTypeList[i].icon;
                        break;
                    }
                }
            }
            if(tmp.mid_table_remark_011){
                if(_this.$route.query.o=='search'){
                    _this.showLocalDictionaryVal(tmp.mid_table_remark_011);
                    _this.projectForm = tmp;
                }else{
                    let requestData = {
                        isloading: true,
                        userId: tmp.mid_table_remark_011
                    };
                    pageCommon.apiRequestCommon(projectApi, "getUserList", requestData).then(
                        (res) => {
                            let userData = res.page_content;
                            tmp.mid_table_remark_011_Value = userData.length
                                ? userData
                                : null;
                            _this.projectForm = tmp;
                        },
                        (err) => {
                            if (err.sysUserLoginError) {
                                _this.$message.error("系统异常，请稍后刷新重试！");
                            } else {
                                _this.$message.error(err.data.msg);
                            }
                        }
                    );
                }
            }else{
                tmp.mid_table_remark_011_Value = [];
                _this.projectForm = tmp;
            }
            
        },
        (err) => {
            if (err.sysUserLoginError) {
                _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
                _this.$message.error(err.data.msg);
            }
            _this.goHistory();
        }
      );
    },
    handleCheckCount: function () {
      let _this = this;
      let setNumber = _this.projectForm.mid_table_remark_004.split(",").length;
      let setRNumber = 0;
      if (_this.projectForm.mid_table_remark_005) {
        setRNumber = _this.projectForm.mid_table_remark_005.split(",").length;
      }
      console.log(setRNumber + setNumber);
      let allNumber = Number(_this.projectForm.mid_table_remark_008);
      if (allNumber - setNumber - setRNumber < 0) {
        this.$message.error("白名单已达最大数量");
        _this.projectForm.mid_table_remark_004 =
          _this.projectForm.mid_table_remark_004
            .split(",")
            .splice(0, allNumber - setRNumber)
            .join(",");
      }
    },
    // 正式白名单
    handleReleaseCheckCount: function () {
      let _this = this;
      let setTNumber = 0;
      // 测试白名单数量
      if (_this.projectForm.mid_table_remark_004) {
        setTNumber = _this.projectForm.mid_table_remark_004.split(",").length;
      }
      // 正式
      let setNumber = _this.projectForm.mid_table_remark_005.split(",").length;
      let allNumber = Number(_this.projectForm.mid_table_remark_008);
      if (allNumber - setNumber - setTNumber < 0) {
        this.$message.error("白名单已达最大数量");
        _this.projectForm.mid_table_remark_005 =
          _this.projectForm.mid_table_remark_005
            .split(",")
            .splice(0, allNumber - setTNumber)
            .join(",");
      }
    },

    selectCodeToValues: function (item, prop, list, ismulit) {
      let _this = this;
      if (item[prop]) {
        let checkArr = `${item[prop]}`.split(",");
        let resultArr = [];
        for (let i = 0; i < checkArr.length; i++) {
          let isBreak = false;
          const checkVal = checkArr[i];
          for (let j = 0; j < list.length; j++) {
            const findVal = list[j];
            if (checkVal == findVal.value) {
              resultArr.push(lodash.cloneDeep(findVal));
              if (!ismulit) {
                isBreak = true;
              }
              break;
            }
          }
          if (isBreak) {
            break;
          }
        }
        return resultArr;
      }
      return [];
    },

    projectTypeChange: function () {
      let _this = this;
      _this.projectForm.mid_table_remark_007 =
        _this.projectForm.mid_table_remark_007_Value.value;
      _this.projectTypeIcon = _this.projectForm.mid_table_remark_007_Value.icon;
    },
    addnewIP: function (prop, formpro) {
      let _this = this;
      if (_this.testWhiteList.length) {
        if (_this.userInfo.user_remark_012 === "1202") {
          if (_this.testWhiteList.length === 10) {
            _this
              .$confirm("专业版版最多只能配置10个白名单", "提示", {
                type: "warning",
              })
              .then(() => {
                _this[prop] = [];
              })
              .catch(() => {
                _this[prop] = [];
              });
          } else {
            if (
              _this[prop] &&
              _this[prop][0] &&
              _this[prop][1] &&
              _this[prop][2] &&
              _this[prop][3]
            ) {
              let targetFormProp = "";
              if (formpro === "testWhiteList") {
                targetFormProp = "mid_table_remark_004";
              } else if (formpro === "releaseWhiteList") {
                targetFormProp = "mid_table_remark_005";
              }
              let originIpList = lodash.cloneDeep(_this[formpro]);
              originIpList.push(
                `${_this[prop][0]}.${_this[prop][1]}.${_this[prop][2]}.${_this[prop][3]}`
              );
              _this.projectForm[targetFormProp] = originIpList.join(",");
              _this[prop] = [];
            }
          }
        } else {
          if (_this.testWhiteList.length === 1) {
            _this
              .$confirm("体验版最多只能配置1个白名单", "提示", {
                type: "warning",
              })
              .then(() => {
                _this[prop] = [];
              })
              .catch(() => {
                _this[prop] = [];
              });
          }
        }
      } else {
        if (
          _this[prop] &&
          _this[prop][0] &&
          _this[prop][1] &&
          _this[prop][2] &&
          _this[prop][3]
        ) {
          let targetFormProp = "";
          if (formpro === "testWhiteList") {
            targetFormProp = "mid_table_remark_004";
          } else if (formpro === "releaseWhiteList") {
            targetFormProp = "mid_table_remark_005";
          }
          let originIpList = lodash.cloneDeep(_this[formpro]);
          originIpList.push(
            `${_this[prop][0]}.${_this[prop][1]}.${_this[prop][2]}.${_this[prop][3]}`
          );
          _this.projectForm[targetFormProp] = originIpList.join(",");
          _this[prop] = [];
        }
      }
    },
    // delWhiteIp: function (formpro, idx) {
    //   let _this = this;
    //   let targetFormProp = "";
    //   if (formpro === "testWhiteList") {
    //     targetFormProp = "mid_table_remark_004";
    //   } else if (formpro === "releaseWhiteList") {
    //     targetFormProp = "mid_table_remark_005";
    //   }
    //   let arr = _this.projectForm[targetFormProp].split(",");
    //   arr.splice(idx, 1);
    //   _this.projectForm[targetFormProp] = arr.join(",");
    // },
    handleSubmit: function () {
      let _this = this;
      _this.isRequesting = true;
      _this.$refs["projectForm"].validate((valid) => {
        if (valid) {
          _this.submitEditProject();
        } else {
          _this.isRequesting = false;
        }
      });
    },
    submitEditProject: function () {
        let _this = this;
        console.log(_this.projectForm.mid_table_remark_011_Value)
        let mid_table_remark_011 = [];
        if(_this.projectForm.mid_table_remark_011_Value.length){
            for (let i = 0; i < _this.projectForm.mid_table_remark_011_Value.length; i++) {
                mid_table_remark_011.push(_this.projectForm.mid_table_remark_011_Value[i].id_public_user_info)
            }
        }
        let page_content = {
            id_public_user_info: _this.userInfo.id_public_user_info,
            mid_table_remark_001: _this.projectForm.mid_table_remark_001,
            mid_table_remark_002: _this.projectForm.mid_table_remark_002,
            mid_table_remark_003: _this.projectForm.mid_table_remark_003,
            mid_table_remark_004: _this.projectForm.mid_table_remark_004,
            mid_table_remark_005: _this.projectForm.mid_table_remark_005,
            mid_table_remark_006: _this.projectForm.mid_table_remark_006,
            mid_table_remark_007: _this.projectForm.mid_table_remark_007,
            mid_table_remark_008: _this.projectForm.mid_table_remark_008,
            mid_table_remark_009: _this.projectForm.mid_table_remark_009,
            mid_table_remark_010: _this.projectForm.mid_table_remark_010,
            mid_table_remark_011: mid_table_remark_011.length?mid_table_remark_011.join(','):'set_value_is_null',
            mid_table_remark_012: _this.projectForm.mid_table_remark_012,
            mid_table_remark_013: _this.projectForm.mid_table_remark_013,
            mid_table_remark_014: _this.projectForm.mid_table_remark_014,
            mid_table_remark_015: _this.projectForm.mid_table_remark_015,
            isloading: true,
        };
        console.log(page_content.mid_table_remark_011)
        if (_this.projectId) {
            page_content["id_public_middle_table"] = _this.projectId;
        }
        pageCommon
        .apiRequestCommon(projectApi, "createProject", page_content)
        .then(
            (res) => {
                _this.isRequesting = false;
                _this.$message.success("操作成功");
                _this.goHistory();
            },
            (err) => {
                _this.isRequesting = false;
                if (err.sysUserLoginError) {
                    _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                    x_this.$message.error(err.data.msg);
                }
            }
        );
    },
    addPartner: function( ){
        let _this = this;
        let isExist = false;
        console.log(_this.selectPartner)
        console.log(_this.selectPartner)
        if(!_this.selectPartner){
            _this.$message.error("请输入要查找的项目协作者用户"); 
            return false
        }
        if(_this.projectForm.mid_table_remark_011_Value.length>0){
            for (let index = 0; index < _this.projectForm.mid_table_remark_011_Value.length; index++) {
                if(_this.projectForm.mid_table_remark_011_Value[index].id_public_user_info==_this.selectPartner.value){
                    isExist = true;
                }
                
            }
        }
        if(!isExist){
            _this.projectForm.mid_table_remark_011_Value.push({
                id_public_user_info: _this.selectPartner.value,
                nick_name: _this.selectPartner.text,
            })
        }else{
            _this.$message.error("此用户已添加"); 
        }
    },
    closeTag: function (item, index) {
        let _this = this;
        _this.projectForm.mid_table_remark_011_Value.splice(index, 1)
    },
    demandTypeChange: function () {
      let _this = this;
      let valArr = [];
      for (
        let i = 0;
        i < _this.projectForm.mid_table_remark_011_Value.length;
        i++
      ) {
        const element = _this.projectForm.mid_table_remark_011_Value[i];
        valArr.push(element.value);
      }
      if (valArr.length <= 0) {
        _this.projectForm.mid_table_remark_011 = null;
      } else {
        _this.projectForm.mid_table_remark_011 = valArr.join(",");
      }
    },
    /*
     * 获取项目行业分类数据
     * */
    getIndustryList: function () {
      let _this = this;
      let requestData = {
        isloading: true,
      };
      pageCommon.apiRequestCommon(projectApi, "getIndustry", requestData).then(
        (res) => {
          _this.projectTypeList = [];
          res.page_content.forEach((item) => {
            _this.projectTypeList.push({
              value: item.id_public_middle_table,
              text: item.mid_table_remark_001,
              icon: item.mid_table_remark_003,
              remark: "",
            });
          });
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";
.custom-el-select {
  width: 100% !important;
}
.projectmanagedetail {
  position: relative;
  width: 100%;
  height: 100%;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  .page-title {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .page-nav-items {
      .page-parentname {
        color: rgba(153, 153, 153, 1);
        cursor: pointer;
      }
    }
  }
  .appid-secret-box {
    position: relative;
    width: 100%;
    height: 140px;
    background: #f4f4f4;
    display: flex;
    align-items: center;
    padding-right: 20px;
    padding-left: 100px;

    border: 1px solid #eeeeee;
    border-radius: 4px;
    box-sizing: border-box;
    margin-top: 40px;
    .appid-secret-main {
      position: relative;
      width: 100%;
      height: 64px;
      display: flex;
      display: -webkit-flex;
      flex-direction: column;
      justify-content: space-between;
      .item-container {
        position: relative;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        align-items: center;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        line-height: 22px;
        .label {
          position: relative;
          width: 125px;

          text-align: left;
        }
        .dot {
          position: relative;
          padding-left: 16px;
          padding-right: 24px;
        }
      }
    }
  }
  .from_item_flex {
    display: flex;
    justify-content: space-between;
  }
  .form-box {
    position: relative;
    width: 100%;
    padding-top: 56px;
    padding-bottom: 48px;
    box-sizing: border-box;
    /deep/.el-form-item {
      margin-bottom: 40px;
      &.custom-el-form-item {
        &.is-required {
          .el-form-item__label {
            // padding: 0 !important;
            &::before {
              content: none;
            }
          }
        }
      }
    }
    /deep/.el-form-item__content {
      text-align: left;
    }
    /deep/.custom-input {
      &.input-with-unit {
        .el-input__inner {
          padding-right: 46px;
        }
        &::after {
          position: absolute;
          content: "万";
          width: 46px;
          height: 46px;
          line-height: 46px;
          right: 0;
          top: 0;

          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: normal;
          color: #222222;
          text-align: center;
        }
      }
      &.project-desc {
        // width: 690px;
        .el-textarea__inner {
          position: relative;
          // width: 690px;
          height: 170px;

          padding: 17px 13px;
          resize: none;

          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: normal;
          color: #222222;
          line-height: 24px;
          &:focus {
            border-color: #07060b;
          }
          &::placeholder {
            color: #c2c2c2;
          }

          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            color: #c2c2c2;
          }

          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 适配火狐 */
            color: #c2c2c2;
          }

          &::-moz-placeholder {
            /* Mozilla Firefox 19+ 适配火狐 */
            color: #c2c2c2;
          }

          &:-ms-input-placeholder {
            /* Internet Explorer 10+  适配ie*/
            color: #c2c2c2;
          }
        }
      }
    }
    .white-count-box {
      position: relative;
      width: 100%;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: normal;
      color: #222222;
      line-height: 16px;
      .white-count {
        position: relative;
        width: 100px;
        height: 46px;
        line-height: 46px;
        background: #f4f4f4;
        border-radius: 4px;
        padding-left: 13px;
        box-sizing: border-box;
        margin-right: 10px;

        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #999999;
      }
    }
    .ip-box {
      position: relative;
      max-height: 300px;
      overflow-y: auto;
      width: 100%;
      .ip-item-box {
        position: relative;
        width: 100%;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        align-items: center;
        &.justshow {
          margin-top: 16px;
        }
        .ip-item-input-inner {
          position: relative;
          width: 492px;
          height: 66px;
          background: #f4f4f4;
          border-radius: 4px;
          padding-left: 14px;
          box-sizing: border-box;
          padding-left: 14px;
          padding-right: 14px;
          display: flex;
          display: -webkit-flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          /deep/.custom-input {
            width: auto;
            .el-input__inner {
              width: 98px;
              height: 38px;
              line-height: 38px;
              background: #ffffff;
              border-radius: 4px;
            }
          }
          .dot {
            position: relative;
            width: 4px;
            height: 4px;
            background: #222222;
            border-radius: 50%;
            box-sizing: border-box;
          }
        }
        .ip-item-show-inner {
          position: relative;
          width: 492px;
          height: 46px;
          line-height: 46px;
          background: #f4f4f4;
          border-radius: 4px;
          padding-left: 14px;
          box-sizing: border-box;
          font-size: 16px;
          font-family: Source Han Sans CN;
          color: #000000;
        }
        .btn-addnew {
          position: relative;

          font-size: 16px;
          font-family: Source Han Sans CN;
          color: #ec4040;
          line-height: 16px;
          margin-left: 24px;
          cursor: pointer;
          &.disabled {
            color: #ffa8a8;
            cursor: auto;
          }
        }
        .icon-delete {
          position: relative;
          width: 24px;
          height: 24px;
          margin-left: 28px;
          cursor: pointer;
        }
      }
      .read-iplist-box {
        position: relative;
        width: 90%;
        max-height: 300px;
        overflow-x: hidden;
        overflow-y: auto;
        .read-ip-item-box {
          position: relative;
          width: 100%;
          margin-bottom: 16px;
        }
      }
    }
    .btn-publish {
      width: 110px;
      height: 46px;
      line-height: 46px;

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
    .btn-cancel {
      width: 94px;
      height: 46px;
      line-height: 46px;

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #222222;
      margin-left: 40px;
    }
    .btn-back {
      width: 94px;
      height: 46px;

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ec4040;
      line-height: 46px;
    }
  }

  .cell-row {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    box-sizing: border-box;

    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    text-align: left;
    // margin-right: 20px;
  }
  .cell-column {
    position: relative;
    text-align: left;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .project-name-cell {
    position: relative;
    width: 156px;
    margin-right: 20px;
  }
  .id-secret-cell {
    position: relative;
    width: 187px;
    margin-right: 25px;
  }
  .status-cell {
    position: relative;
    width: 65px;
    margin-right: 35px;
  }
  .white-cell {
    position: relative;
    width: 96px;
    margin-right: 30px;
  }
  .creattime-cell {
    position: relative;
    width: 83px;
    margin-right: 38px;
  }
  .operate-cell {
    position: relative;
    width: 203px;
    text-align: center;
  }
  .table-header-box {
    position: relative;

    height: 60px;
    background: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 35px;
    margin-bottom: 24px;
    .status-cell {
      text-align: center;
    }
    .creattime-cell {
      text-align: center;
    }
  }
  .table-list-box {
    position: relative;
    flex: 1;
    width: 100%;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .datalist-row {
    height: 100px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 24px;
    &:nth-child(2n) {
      background: #f6f6f6;
    }
    &:last-child {
      margin-bottom: 0;
    }

    .cell-column {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
    }
    .operate-cell {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ec4040;
      line-height: 16px;
      div {
        cursor: pointer;
      }
    }
    .white-cell {
      text-align: center;
    }
  }
  .el-form-item {
    margin-bottom: 55px;
  }
}
</style>
